import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CountryService} from "@biletix/core/services/country.service";
import {CityService} from "@biletix/core/services/city.service";
import {TownService} from "@biletix/core/services/town.service";
import {Country} from "@biletix/core/models/country.model";
import {City} from "@biletix/core/models/city.model";
import {Town} from "@biletix/core/models/town.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomerAddress} from "@biletix/core/models/customer/customer-address.model";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";

@Component({
    selector: 'btx-address-information-form',
    templateUrl: './address-information-form.component.html',
    styleUrls: ['./address-information-form.component.scss'],
  standalone: false
})
export class AddressInformationFormComponent extends AbstractionComponent implements OnInit, OnDestroy {


    @Input("group") parentForm: FormGroup | any;

    @Input("address") editAddress: CustomerAddress | any;

    @Input("isAddressNameVisible") isAddressNameVisible: boolean = true;


    //Lazy data load
    countryList: Country[] = [];
    cityList: City[] = [];
    townList: Town[] = [];

    selectedCountry: Country | any;
    selectedCity: Country | any;


    defaultCountryCode: string = 'TR';
    isDomesticAddress: boolean = true;

    addressForm: FormGroup | any;

    constructor(private countryService: CountryService,
                private cityService: CityService,
                private townService: TownService,
                private fb: FormBuilder) {
        super();
        this.getAllCountry();
    }


    ngOnInit() {
        this.initializeAddressForm();
    }

    initializeAddressForm() {

        let id: number | any = null,
            line1: string = '',
            title: string = '',
            cityName: City | any = '',
            province: string | any = '',
            countryCode: Country | any = this.defaultCountryCode,
            townName: Town | any = '';


        //if mode edit
        //TODO: Yabancı ülke desteği yok daha sonra eklenecek.
        if (this.editAddress) {
            let address = this.editAddress;
            id = address.id;
            province = address.province;
            cityName = address.city?.name;
            countryCode = address.country?.code;
            townName = address.town?.name;
            line1 = address.line1 + ' ' + (address.line2 ?? '');//TODO:
            title = address.title;

            this.isDomesticAddress = countryCode == this.defaultCountryCode;

            if (this.isDomesticAddress) {
                if (countryCode) {
                    this.getAllCitiesByCountryId(address.country.id);
                }
                if (cityName) {
                    this.getAllTownsByCityId(address.city.id);
                }
            }
        }


        this.addressForm = this.fb.group({
                id: [id],
                line1: [line1, Validators.required],
                countryCode: [countryCode, Validators.required],
                cityName: [cityName, Validators.required],
                townName: [townName, Validators.required],
                province: [province,[Validators.maxLength(80)]]
            }
        );

        if (this.isAddressNameVisible) {
            this.addressForm.addControl('title', this.fb.control(title, [Validators.required,Validators.maxLength(50)]));
        }

        this.parentForm.setControl("addressInfo", this.addressForm);
    }

    getAllCountry() {
        this.countryService
            .getAllCountry()
            .pipe(this.takeUntilDestroy())
            .subscribe(countryList => {
                    this.countryList = countryList;
                    //default olarak Türkiye seç
                    if (!this.editAddress) {
                        this.onCountrySelect(this.defaultCountryCode);
                    }
                }
            );
    }

    getAllCitiesByCountryId(countryId: number) {
        this.cityService
            .getCityListByCountryId(countryId)
            .pipe(this.takeUntilDestroy())
            .subscribe(cityList => this.cityList = cityList);
    }

    getAllTownsByCityId(cityId: number) {
        this.townService
            .getTownListByCityId(cityId)
            .pipe(this.takeUntilDestroy())
            .subscribe(townList => {
                this.townList = townList;
                this.sortTownList();
            });
    }

    sortTownList() {
        if (this.townList && this.townList.length > 0) {
            this.townList.sort((a, b) => a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' }));
        }
    }


    onCountrySelect(countryCode: string) {
        this.selectedCountry = this.countryList.find(c => c.code == countryCode);
        this.isDomesticAddress = countryCode == this.defaultCountryCode;

        let townControl = this.addressForm.get('townName');
        if (this.isDomesticAddress && this.selectedCountry) {
            this.getAllCitiesByCountryId(this.selectedCountry.id);
            townControl?.setValidators([Validators.required]);
        } else {
            townControl?.clearValidators();
            townControl?.updateValueAndValidity();
            this.cityList = [];
            this.townList = [];
        }


        this.addressForm?.patchValue({
                cityName: '',
                townName: '',
                province: ''
            }
        );

        this.addressForm.updateValueAndValidity();

    }

    onCitySelect(cityName: string) {
        this.selectedCity = this.cityList.find(city => city.name == cityName);
        if (this.selectedCity) {
            this.getAllTownsByCityId(this.selectedCity.id);
        }
    } 

}
